/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetFloorplans200ResponseInner,
  GetTableGroups200ResponseInner,
} from '../models/index';
import {
    GetFloorplans200ResponseInnerFromJSON,
    GetFloorplans200ResponseInnerToJSON,
    GetTableGroups200ResponseInnerFromJSON,
    GetTableGroups200ResponseInnerToJSON,
} from '../models/index';

export interface CreateTableGroupRequest {
    floorplanId: string;
    getTableGroups200ResponseInner: GetTableGroups200ResponseInner;
}

export interface DeleteFloorplanRequest {
    floorplanId: string;
}

export interface DeleteTableGroupRequest {
    tableGroupId: string;
}

export interface GetTableGroupsRequest {
    floorplanId: string;
}

export interface UpdateFloorplansRequest {
    getFloorplans200ResponseInner?: Array<GetFloorplans200ResponseInner>;
}

export interface UpdateTableGroupRequest {
    floorplanId: string;
    getTableGroups200ResponseInner: GetTableGroups200ResponseInner;
}

/**
 * 
 */
export class FloorplanApi extends runtime.BaseAPI {

    /**
     */
    async createTableGroupRaw(requestParameters: CreateTableGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['floorplanId'] == null) {
            throw new runtime.RequiredError(
                'floorplanId',
                'Required parameter "floorplanId" was null or undefined when calling createTableGroup().'
            );
        }

        if (requestParameters['getTableGroups200ResponseInner'] == null) {
            throw new runtime.RequiredError(
                'getTableGroups200ResponseInner',
                'Required parameter "getTableGroups200ResponseInner" was null or undefined when calling createTableGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/floorplans/table-groups/{floorplanId}`.replace(`{${"floorplanId"}}`, encodeURIComponent(String(requestParameters['floorplanId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetTableGroups200ResponseInnerToJSON(requestParameters['getTableGroups200ResponseInner']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createTableGroup(requestParameters: CreateTableGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createTableGroupRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteFloorplanRaw(requestParameters: DeleteFloorplanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['floorplanId'] == null) {
            throw new runtime.RequiredError(
                'floorplanId',
                'Required parameter "floorplanId" was null or undefined when calling deleteFloorplan().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/floorplans/{floorplanId}`.replace(`{${"floorplanId"}}`, encodeURIComponent(String(requestParameters['floorplanId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteFloorplan(requestParameters: DeleteFloorplanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteFloorplanRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteTableGroupRaw(requestParameters: DeleteTableGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tableGroupId'] == null) {
            throw new runtime.RequiredError(
                'tableGroupId',
                'Required parameter "tableGroupId" was null or undefined when calling deleteTableGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/floorplans/table-groups/{tableGroupId}`.replace(`{${"tableGroupId"}}`, encodeURIComponent(String(requestParameters['tableGroupId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteTableGroup(requestParameters: DeleteTableGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTableGroupRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getFloorplansRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetFloorplans200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/floorplans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetFloorplans200ResponseInnerFromJSON));
    }

    /**
     */
    async getFloorplans(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetFloorplans200ResponseInner>> {
        const response = await this.getFloorplansRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getTableGroupsRaw(requestParameters: GetTableGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetTableGroups200ResponseInner>>> {
        if (requestParameters['floorplanId'] == null) {
            throw new runtime.RequiredError(
                'floorplanId',
                'Required parameter "floorplanId" was null or undefined when calling getTableGroups().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/floorplans/table-groups/{floorplanId}`.replace(`{${"floorplanId"}}`, encodeURIComponent(String(requestParameters['floorplanId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetTableGroups200ResponseInnerFromJSON));
    }

    /**
     */
    async getTableGroups(requestParameters: GetTableGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetTableGroups200ResponseInner>> {
        const response = await this.getTableGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateFloorplansRaw(requestParameters: UpdateFloorplansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/floorplans`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['getFloorplans200ResponseInner']!.map(GetFloorplans200ResponseInnerToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateFloorplans(requestParameters: UpdateFloorplansRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateFloorplansRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateTableGroupRaw(requestParameters: UpdateTableGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['floorplanId'] == null) {
            throw new runtime.RequiredError(
                'floorplanId',
                'Required parameter "floorplanId" was null or undefined when calling updateTableGroup().'
            );
        }

        if (requestParameters['getTableGroups200ResponseInner'] == null) {
            throw new runtime.RequiredError(
                'getTableGroups200ResponseInner',
                'Required parameter "getTableGroups200ResponseInner" was null or undefined when calling updateTableGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/floorplans/table-groups/{floorplanId}`.replace(`{${"floorplanId"}}`, encodeURIComponent(String(requestParameters['floorplanId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GetTableGroups200ResponseInnerToJSON(requestParameters['getTableGroups200ResponseInner']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateTableGroup(requestParameters: UpdateTableGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateTableGroupRaw(requestParameters, initOverrides);
    }

}
